<button
  mat-fab
  matTooltip="Add coupon"
  color="primary"
  class="fab fab-fixed-right"
  (click)="add({ enabled: true })"
>
  <mat-icon>add</mat-icon>
</button>

<div class="card-container">
  <mat-card fxLayout="column">
    <mat-form-field
      appearance="standard"
      style="padding: 0px 15px 0 15px;"
      fxFlex
    >
      <mat-label>Search</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        (keyup)="applyFilter($event.target.value)"
        placeholder="Type something..."
      />
    </mat-form-field>

    <table
      mat-table
      class="mat-elevation-8 mat-typography"
      [dataSource]="dataSource"
      matSort
    >
      <ng-container matColumnDef="code">
        <th *matHeaderCellDef mat-sort-header>Code</th>
        <td *matCellDef="let coupon">{{ coupon.code }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th *matHeaderCellDef mat-sort-header>Type</th>
        <td *matCellDef="let coupon">
          {{ coupon.type }}
        </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th *matHeaderCellDef mat-sort-header>Value</th>
        <td *matCellDef="let coupon">
          <span *ngIf="coupon.type === 'PERCENTAGE'"
            >{{ coupon.value * 100 }}%</span
          >
          <span *ngIf="coupon.type === 'AMOUNT'">{{ coupon.value }}€</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="expire">
        <th *matHeaderCellDef mat-sort-header>Expire</th>
        <td *matCellDef="let coupon">
          <span *ngIf="coupon.expire">{{
            coupon?.expire.toDate() | date
          }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="notes">
        <th *matHeaderCellDef>Notes</th>
        <td *matCellDef="let coupon">
          {{ coupon?.notes }}
        </td>
      </ng-container>

      <ng-container matColumnDef="limit">
        <th *matHeaderCellDef>Usage Limit</th>
        <td *matCellDef="let coupon">
          {{ coupon?.limit }}
        </td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th *matHeaderCellDef mat-sort-header>Enabled</th>
        <td *matCellDef="let coupon">
          {{ coupon.enabled ? "yes" : "no" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef></th>
        <td *matCellDef="let coupon" class="text-right">
          <button mat-icon-button (click)="delete(coupon, $event)">
            <mat-icon matListIcon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        class="clickable"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="edit(row)"
      ></tr>
    </table>
  </mat-card>
</div>
